import {auth0ClientProvider} from "../../components/auth/SSO";

const esc = encodeURIComponent;
const baseUrl = `${process.env.REACT_APP_SKADI_BASE_URL}/api/v1`;

async function buildAuthRequest(method = undefined, headers = undefined, body = undefined) {
    return auth0ClientProvider.getTokenSilently()
        .then((token) => {
            return {
                method,
                headers: Object.assign({
                    Authorization: `Bearer ${token}`
                }, headers),
                body
            }
        });
}

function buildQueryString(params) {
    const query = Object.keys(params)
        .reduce((data, key) => {
            const value = params[key];

            if (value) data.push(`${esc(key)}=${esc(params[key])}`);

            return data;
        }, []);

    return query.length ? `?${query.join('&')}` : "";
}

function handleJsonResponse(res) {
    const json = res.json();

    return res.ok
        ? json.then(content => content.success
            ? Promise.resolve(content.result)
            : Promise.reject(content.error))
        : json.then(content => Promise.reject(content.error));
}

export {
    baseUrl,
    buildAuthRequest,
    buildQueryString,
    handleJsonResponse
}